import React from 'react';
import { SuggestionBulbIcon } from './homePageIconsNew';

const SuggestionModal = ({
  suggestionEmail,
  setSuggestionEmail,
  suggestionCategory,
  setSuggestionCategory,
  suggestionMessage,
  setSuggestionMessage,
  suggestionStatus,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-md px-4 transition-all duration-300">
      <div className="relative w-full max-w-lg overflow-hidden rounded-[32px] border border-slate-100 bg-white p-6 sm:p-8 shadow-2xl transition-all duration-300 dark:bg-slate-900 dark:border-slate-800">
        
        {/* Background gradient decorative shapes */}
        <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-blue-500/10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 rounded-full bg-purple-500/10 blur-3xl pointer-events-none" />

        <div className="relative z-10">
          {/* Header Section */}
          <div className="mb-6 flex items-start justify-between gap-4">
            <div className="flex items-center gap-3">
              <SuggestionBulbIcon />
              <div>
                <span className="inline-block text-[0.7rem] font-black uppercase tracking-widest text-[#0066FF]">
                  New Category
                </span>
                <h3 className="text-2xl font-extrabold text-slate-900 dark:text-white tracking-tight leading-tight">
                  Send Suggestion
                </h3>
              </div>
            </div>
            
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              aria-label="Close suggestion form"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-900 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-white transition-colors duration-200 font-bold text-lg disabled:opacity-50"
            >
              ✕
            </button>
          </div>

          <p className="mb-6 text-sm text-slate-600 dark:text-slate-300 font-medium leading-relaxed">
            Share the next sports idea you want to see. We will review it from the admin panel.
          </p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300">
                Your Email
              </label>
              <input
                type="email"
                id="email"
                value={suggestionEmail}
                onChange={(e) => setSuggestionEmail(e.target.value)}
                placeholder="your.email@example.com"
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-[#0066FF] focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:focus:border-blue-500 font-medium transition-all duration-200"
                required
                disabled={isSubmitting}
              />
            </div>

            <div>
              <label htmlFor="category" className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300">
                Category Suggestion
              </label>
              <input
                type="text"
                id="category"
                value={suggestionCategory}
                onChange={(e) => setSuggestionCategory(e.target.value)}
                placeholder="e.g., Tennis Trivia, Basketball Stats"
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-[#0066FF] focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:focus:border-blue-500 font-medium transition-all duration-200"
                required
                disabled={isSubmitting}
              />
            </div>

            <div>
              <label htmlFor="message" className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300">
                Message
              </label>
              <textarea
                id="message"
                value={suggestionMessage}
                onChange={(e) => setSuggestionMessage(e.target.value)}
                placeholder="Tell us about the category you'd like to see..."
                rows="3"
                className="w-full resize-none rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-[#0066FF] focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-500/10 dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:focus:border-blue-500 font-medium transition-all duration-200"
                required
                disabled={isSubmitting}
              />
            </div>

            {suggestionStatus === 'success' && (
              <div className="rounded-2xl bg-emerald-500 px-4 py-3 text-center text-sm font-bold text-white shadow-sm">
                ✓ Suggestion sent successfully!
              </div>
            )}
            {suggestionStatus === 'invalid-email' && (
              <div className="rounded-2xl bg-amber-500 px-4 py-3 text-center text-sm font-bold text-white shadow-sm">
                ! Please enter a valid email address.
              </div>
            )}
            {(suggestionStatus === 'failed' || suggestionStatus === 'network-error' || suggestionStatus === 'error') && (
              <div className="rounded-2xl bg-rose-500 px-4 py-3 text-center text-sm font-bold text-white shadow-sm">
                {suggestionStatus === 'error'
                  ? '! Please fill in all fields before sending.'
                  : '! Unable to send your suggestion right now. Please try again.'}
              </div>
            )}

            <div className="flex flex-col-reverse gap-3 pt-3 sm:flex-row">
              <button
                type="button"
                onClick={onClose}
                disabled={isSubmitting}
                className="flex-1 rounded-2xl border border-slate-200 bg-slate-100 px-4 py-3.5 text-sm font-bold text-slate-700 hover:bg-slate-200 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 transition-colors duration-200 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`flex-1 rounded-2xl bg-[#0066FF] hover:bg-blue-700 text-white px-4 py-3.5 text-sm font-bold shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 ${
                  isSubmitting ? 'opacity-60 cursor-not-allowed' : ''
                }`}
              >
                <svg className="w-4 h-4 fill-current transform rotate-[-20deg]" viewBox="0 0 24 24">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                </svg>
                <span>{isSubmitting ? 'Sending...' : 'Send Suggestion'}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SuggestionModal;
